module.exports = __webpack_public_path__ + "img/logo.47ede9cd.png";